class CookieUtils
{
    public saveCookie(cookieName, cookieValue, expireDays)
    {
        let encodedValue = encodeURIComponent(cookieValue)
        var d = new Date();
        d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cookieName + "=" + encodedValue + "; Path=/;" + expires;
    }

    public getCookie(cookieName)
    {
        var name = cookieName + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++)
        {
            var c = ca[i];
            while (c.charAt(0) == ' ')
            {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0)
            {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    public deleteCookie(cookieName)
    {
        document.cookie = cookieName + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}

export default new CookieUtils();
